<template>
  <TableApp
    titulo="Tributações"
    subTitulo="Cadastre suas tributações para fazer suas compras e vendas"
    acaoBtn="/#/tributacoes/nova"
    textoBtn="Nova Tributação"
    api-url="tributacao"
    :fields="fields"
    classFilterColumn="tributacao"
    ref="tributacao"
    :perPage="10"
  >
    <template slot="customRow" slot-scope="props">
      <span slot="descricao" v-if="props.field == 'descricao'">
        <span style="width: 110px">
          <div class="font-weight-bold text-muted">
            {{ props.rowData.descricao }}
          </div>
        </span>
      </span>
      <span slot="actions" v-if="props.field == 'actions'">
        <div class="row-actions" style="text-align: right !important">
          <span style="overflow: visible; position: relative; width: 130px">
            <div class="dropdown dropdown-inline">
              <router-link
                class="btn btn-sm btn-info btn-hover-info btn-icon mr-2"
                v-b-tooltip="'Editar'"
                v-if="props.rowData.id_empresa"
                :to="{
                  name: 'tributacoesEditar',
                  params: {
                    id: props.rowData.id,
                  },
                }"
              >
                <Pencil :size="16" title="Editar" />
              </router-link>
              <button
                v-if="props.rowData.id_empresa"
                @click="excluir(props.rowData)"
                class="btn btn-sm btn-danger btn-hover-danger btn-icon mr-2"
                v-b-tooltip="'Excluir'"
              >
                <TrashCanIcon :size="16" />
              </button>
            </div>
          </span>
        </div>
      </span>
    </template>
  </TableApp>
</template>

<script>
import { mapGetters } from "vuex";
import Pencil from "vue-material-design-icons/Pencil.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import TableApp from "@/components/Table/Table2";

export default {
  name: "app-tributacao",
  components: {
    Pencil,
    TrashCanIcon,
    TableApp,
  },
  data() {
    return {
      fields: [
        {
          label: "Descrição",
          field: "descricao",
          type: "text",
          slot: true,
          sortable: false,
          width: "40%",
          filterOptions: {
            enabled: true,
            placeholder: "Pesquisar pela descrição",
          },
        },
        {
          label: "Ações",
          field: "actions",
          sortable: false,
          slot: true,
          width: "10%",
          filterOptions: {
            enabled: false,
          },
        },
      ],
    };
  },
  methods: {
    excluir(data) {
      this.$swal
        .fire({
          icon: "warning",
          title: "Excluir a tributação " + data.descricao + "?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await this.$http.post("/tributacao/delete", {
              id: data.id,
            });
            this.$refs.tributacao.refresh();
            this.$toast.success("Tributação excluída!");
          }
        });
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked"]),
    config() {
      return this.layoutConfig();
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
</script>
